module.exports = __webpack_public_path__ + "img/logout.c705413f.svg";